import { JL } from 'jsnlog';
import { config } from '../../../config';
import { LogEntry, LogLevel, Appenders, LoggingConfig } from './logger-types';

let isInitialised = false;

const getTimeStamp = (): string => new Date().toISOString();

export const addEntry = (level: LogLevel, entry: LogEntry): void => {
    JL().log(level, entry);
};

let savedAjaxAppender: JL.JSNLogAjaxAppender;

export function printInConsole(level: LogLevel, entry: LogEntry): void {
    const args = [getTimeStamp().split('T')[1].replace('Z', ''), entry];
    switch (level) {
        case LogLevel.FATAL:
        case LogLevel.ERROR:
            console.error(...args);
            break;
        case LogLevel.WARN:
            console.warn(...args);
            break;
        case LogLevel.INFO:
            console.info(...args);
            break;
        case LogLevel.TRACE:
            console.trace(...args);
            break;
        case LogLevel.DEBUG:
            console.debug(...args);
            break;
    }
    return;
}

export const initialiseLogger = (): void => {
    if (isInitialised) {
        return;
    }

    window.addEventListener('beforeunload', (event) => {
        if (savedAjaxAppender?.sendBatch !== undefined) {
            savedAjaxAppender.sendBatch();
        }
    });

    isInitialised = true;

    const settings: LoggingConfig = config.logging;
    if (!settings) {
        console.error('Logging settings are not provided');
        return;
    }

    if (!settings.appenders || settings.appenders.length === 0) {
        return;
    }
    const appenders = [];

    if (settings.appenders.includes(Appenders.console)) {
        appenders.push(JL.createConsoleAppender('consoleAppender'));
    }

    if (settings.appenders.includes(Appenders.ajax)) {
        const ajaxAppender = setAjaxAppender(settings);
        appenders.push(ajaxAppender);
    }

    JL().setOptions({ appenders });
};

function setAjaxAppender(settings: LoggingConfig): any {
    const batchSize = settings.batchSize || 1;
    const maxBatchSize = settings.maxBatchSize || 20;

    const ajaxOptions = {
        url: settings.endpoint,
        batchTimeout: settings.batchTimeoutMs,
        batchSize: batchSize,
        maxBatchSize: maxBatchSize,
        level: settings.level,
    };

    savedAjaxAppender = JL.createAjaxAppender('ajaxAppender');

    savedAjaxAppender.setOptions?.(ajaxOptions);

    return savedAjaxAppender;
}

export const addLoginEntry = (entry: any): void => {
    initialiseLogger();
    JL().log(LogLevel.INFO, entry);
};
